module.exports = __webpack_public_path__ + "static/bot6-430c128c9a36d9cc2aa7a0c1b22f3507.jpg";